/* eslint-disable jsx-a11y/label-has-associated-control */
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import type { Props } from 'react-select';
import Select from 'react-select';
import { generateSelectFieldClassNames } from '@/DesignSystem/Helper/generateSelectFieldClassNames';
import type { IFieldProps } from '@/DesignSystem/Model/DataModel';

// @ts-ignore
interface ISelectFieldProps extends IFieldProps, Props {}
const SelectField: FC<ISelectFieldProps> = ({
  control,
  name,
  defaultValue,
  prefix,
  suffix,
  label,
  ...props
}) => {
  return <Controller name={name} control={control} defaultValue={defaultValue ?? null} render={({
    field,
    fieldState
  }) => {
    const error = fieldState.error?.message || '';
    return <>
            <div className={generateSelectFieldClassNames({
        ...props,
        hasError: !!error,
        hasValue: field.value !== undefined && field.value !== null && String(field.value).length > 0
      })}>
              <label>
                {label && <div className="ui__selectField__label  ">{label}</div>}
                <div className="ui__selectField__content ">
                  {prefix && <div className="ui__selectField__prefix">{prefix}</div>}
                  <Select className="ui__selectField__element ui__selectField--type-select   " classNamePrefix="authGradCustom" {...props} {...field} />
                  {suffix && <div className="ui__selectField__suffix">{suffix}</div>}
                </div>
              </label>
            </div>
            {error && <div className="ui__selectField__error">{error}</div>}
          </>;
  }} data-sentry-element="Controller" data-sentry-component="SelectField" data-sentry-source-file="SelectField.tsx" />;
};
SelectField.defaultProps = {
  size: 'middle'
};
export default SelectField;